import { actions } from "@grandvisionhq/state";
import { startPrescriptionGlassesConfiguration } from "../../../state/actions.js";
import { fetchLensTypesSuccess, fetchPackagesSuccess, fetchAddOnsSuccess } from "../../../bundles/state/bundles/actions.js";
const indexBySku = (m, p) => {
  if (!p.masterVariant.sku) {
    return m;
  }
  return {
    ...m,
    [p.masterVariant.sku]: p
  };
};
const reduceProducts = (products) => products.reduce(indexBySku, {});
const initialState = {
  frames: {},
  lensTypes: {},
  variants: {},
  packages: {},
  addOns: {}
};
const reduceVariant = (masterSku) => (m, variant) => {
  if (!variant.sku || !variant.isMatchingVariant) {
    return m;
  }
  return {
    ...m,
    [variant.sku]: masterSku
  };
};
const indexAllVariantsBySKU = (m, product) => {
  const { sku: masterSku } = product.masterVariant;
  if (!masterSku) {
    return m;
  }
  return {
    ...m,
    // We also record a reference for the masterVariant to make lookups simpler
    [masterSku]: masterSku,
    ...product.variants.reduce(reduceVariant(masterSku), {})
  };
};
const addToLookup = (s, products) => ({
  ...s.variants,
  ...products.reduce(indexAllVariantsBySKU, {})
});
const reducer = actions.reducer(
  initialState,
  actions.on(
    fetchLensTypesSuccess,
    (s, { payload: { products } }) => ({
      ...s,
      lensTypes: {
        ...s.lensTypes,
        ...reduceProducts(products)
      },
      variants: addToLookup(s, products)
    })
  ),
  actions.on(
    fetchPackagesSuccess,
    (s, { payload: { products } }) => ({
      ...s,
      packages: {
        ...s.packages,
        ...reduceProducts(products)
      }
    })
  ),
  actions.on(
    fetchAddOnsSuccess,
    (s, { payload: { products } }) => ({
      ...s,
      addOns: {
        ...s.addOns,
        ...reduceProducts(products)
      },
      variants: addToLookup(s, products)
    })
  ),
  actions.on(
    startPrescriptionGlassesConfiguration,
    (s, { payload: { frame, frameSku } }) => ({
      ...s,
      frames: {
        ...s.frames,
        [frameSku]: frame
      }
    })
  )
);
export {
  initialState,
  reducer
};
//# sourceMappingURL=reducer.js.map
